import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import styles from './Notes.module.css'
import { getNotesLog, updateNotes } from "../../../../store/slices/individualFiles/thunks";
import { Table } from "react-bootstrap";

export const Notes = ({ individualFile }) => {
  const { notesLog } = useSelector((state) => state.individualFiles);
  const dispatch = useDispatch();
  const [notes, setNotes] = useState(individualFile.notes);

  const save = () => {
    const success = () => { };
    dispatch(updateNotes(notes, individualFile.id, success));
  }

  useEffect(() => {
    dispatch(getNotesLog(individualFile.id));
  }, [])


  return (
    <>
      <div className="col-lg-12 col-md-12">
        <div className=" row mb-4">
          <textarea className="form-control" type="text" rows="10" value={notes}
            onChange={e => setNotes(e.target.value)}
          />
        </div>
      </div>
      <button className="btn btn-light" style={{ marginTop: 20, marginBottom: 20 }}
        onClick={() => save(true)} >Guardar</button>

      <div className="table-responsive">
        <Table className="table border text-nowrap text-md-nowrap mg-b-0">
          <thead>
            <tr>
              <th>#</th>
              <th>Notas</th>
              <th>Agente</th>
              <th>Fecha de modificacion</th>
            </tr>
          </thead>
          <tbody>
            {
              notesLog.map((record, index) => (
                <tr key={record.id}>
                  <td>{index+1}</td>
                  <td>{record.notes}</td>
                  <td>{record.agent}</td>
                  <td>{record.insertDate}</td>
                </tr>
              ))
            }

          </tbody>
        </Table>
      </div>
    </>
  )
}
